import React, { useEffect, useState } from "react";
import {
  Typography,
  Form,
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  message,
} from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LogoImg from "../../../assets/images/smallLogo.svg";
import BannerImg from "../../../assets/images/banner.png";
import { adminLogin } from "../../../redux/action/auth/authAction";
import FullScreenLoader from "../../../components/common/loader/FullScreenLoader";

const { Title, Text } = Typography;

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    // setLoading(true);
    const { rememberMe, ...loginPayload } = values;
    try {
      dispatch(
        adminLogin(
          loginPayload,
          () => {
            if (rememberMe) {
              localStorage.setItem("REMEMBERED_EMAIL", loginPayload?.email);
            } else {
              localStorage.removeItem("REMEMBERED_EMAIL");
            }
            setLoading(false);
            navigate("/dashboard");
          },
          (errorMessage) => {
            setLoading(false);
            form.setFields([
              {
                name: "password",
                errors: [
                  errorMessage || "Invalid credentials. Please try again.",
                ],
              },
            ]);
          }
        )
      );
    } catch (error) {
      setLoading(false);
      message.error("Login failed. Please check your credentials.");
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("REMEMBERED_EMAIL");
    if (savedEmail) {
      form.setFieldsValue({ email: savedEmail, rememberMe: true });
    }
  }, []);

  return (
    <>
      <FullScreenLoader loading={loading} />
      <div className="signinContainer">
        <Row gutter={16} className="signinRow">
          <Col xs={24} sm={12}>
            <div className="leftSection cflex">
              <div className="leftContainer">
                <img
                  src={LogoImg}
                  alt="Logo"
                  className="logo"
                  height={200}
                  width={200}
                />
                <Title level={2}>Hey, Welcome! 👋</Title>
                <Text className="subtitle mb-2">
                  Please sign in to your account to access our application
                </Text>
                <Form
                  form={form}
                  name="signin"
                  layout="vertical"
                  onFinish={handleSubmit}
                  // initialValues={{ rememberMe: false }}
                  initialValues={{}}
                  className="signin-form"
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email!" },
                      { type: "email", message: "Enter a valid email!" },
                    ]}
                  >
                    <Input size="large" placeholder="Email" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your password!",
                      },
                      // {
                      //   pattern:
                      //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      //   message:
                      //     "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      // },
                    ]}
                  >
                    <Input.Password size="large" placeholder="Password" />
                  </Form.Item>

                  <Form.Item name="rememberMe" valuePropName="checked">
                    <div className="dflex">
                      <Checkbox>Remember me</Checkbox>
                      <a
                        href="#"
                        className="forgotPassword"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/forgot-password");
                        }}
                      >
                        Forgot Password?
                      </a>
                    </div>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      className="customButton mt-3"
                      htmlType="submit"
                    >
                      Login Now
                    </Button>
                  </Form.Item>
                </Form>
                <Text className="subtitle mt-5 text-center">
                  © Cultivate 2025
                </Text>
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="rightSection cflex">
              <img src={BannerImg} alt="Banner" className="banner" />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SignIn;
